import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

import { CheckboxGroupFieldProps } from './CheckboxGroupField.types';

export const CheckboxGroupField = ({ items, name }: CheckboxGroupFieldProps) => {
  const { control } = useFormContext();
  const values = useWatch<string[]>({
    control,
    name,
  });

  const handleCheck = (checkedValue: string) => {
    return values?.includes(checkedValue)
      ? values?.filter(id => id !== checkedValue)
      : [...(values ?? []), checkedValue];
  };

  return (
    <Controller
      name={name}
      render={props => (
        <>
          {items.map(item => (
            <FormControlLabel
              control={
                <Checkbox
                  onChange={() => props.onChange(handleCheck(item.value))}
                  checked={values?.includes(item.value)}
                />
              }
              key={item.value}
              label={item.label}
            />
          ))}
        </>
      )}
      control={control}
    />
  );
};
